module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.access > 2) ? _c('div', {
    staticClass: "col-md-4 dragme"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt arrow-move",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "module-name"
  }, [_vm._v("Caseload Summary")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "portlet-body",
    staticStyle: {
      "height": "300px",
      "overflow": "hidden"
    }
  }, [(_vm.data.access > 3) ? _c('div', {
    staticClass: "table-scrollable table-scrollable-borderless"
  }, [_c('table', {
    staticClass: "table table-hover table-light"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.data.caseload_summary), function(n, key, idx) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Participant Directory Search',
          params: {
            query: {
              case: n.fullName
            }
          }
        },
        "tag": "a"
      }
    }, [_vm._v("\n                " + _vm._s(n.fullName) + "\n              ")])], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(" " + _vm._s(n.total) + " ")])])])
  }), 0)])]) : _c('div', {
    staticClass: "table-scrollable table-scrollable-borderless"
  }, [_c('table', {
    staticClass: "table table-hover table-light"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.data.caseload_summary), function(n, key, idx) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Participant Directory Search',
          params: {
            query: {
              case: ((_vm.data.first_name) + " " + (_vm.data.last_name)),
              status: key
            }
          }
        },
        "tag": "a"
      }
    }, [_vm._v("\n                " + _vm._s(key) + "\n              ")])], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(" " + _vm._s(n) + " ")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-bar-chart font-dark hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark bold uppercase"
  }, [_vm._v("Caseload Summary")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "uppercase"
  }, [_c('th', [_vm._v(" CASE MANAGER ")]), _vm._v(" "), _c('th', [_vm._v(" CASES ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "uppercase"
  }, [_c('th', [_vm._v(" STATUS ")]), _vm._v(" "), _c('th', [_vm._v(" CASES ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7acbdf11","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CaseloadSummary.vue
// module id = 1706
// module chunks = 1